import { makeText } from "../../../util";

const COLOR_MAP = {
  partial: 'yellow',
  accepted: 'green',
  rejected: 'grey',
};

export const StackTitle = ({ dev, stack, selected, language, settings, usePurModel }) => {
  const counts = { active: 0, rejected: 0 };
  stack.categories.forEach(c => {
    if (selected === 'consent' && c.active) {
      counts.active += 1;
    } else if (selected === 'consent' && !c.active) {
      counts.rejected += 1;
    }
    if (selected === 'li' && c.legInt) {
      counts.active += 1;
    } else if (selected === 'li' && !c.legInt) {
      counts.rejected += 1;
    }
  });

  const statusText = makeText(Boolean(dev), settings, 'statusText', language);
  const acceptedAllText = makeText(Boolean(dev), settings, 'acceptedAllText', language);
  const rejectedAllText = makeText(Boolean(dev), settings, 'rejectedAllText', language);
  const partialConsentText = makeText(Boolean(dev), settings, 'partialConsentText', language);

  let status = partialConsentText;
  let actualStatus = 'partial';
  if (counts.active > 0 && counts.rejected === 0) {
    status = acceptedAllText;
    actualStatus = 'accepted';
  }
  if (counts.rejected > 0 && counts.active === 0) {
    status = rejectedAllText;
    actualStatus = 'rejected';
  }

  const statusFont = { ...settings.accordionsFont };
  delete statusFont.color;

  return (
    <div className="stack-title">
      <h4 style={{ ...settings.accordionsFont }}>{stack.name}</h4>
      {!usePurModel && ( 
        <div className="stack-status">
          <span>{statusText}:</span>
          <span style={{ ...statusFont }} className={COLOR_MAP[actualStatus]}>{status}</span>
        </div>
      )}
    </div>
  );
};